import { render, staticRenderFns } from "./BaseBarcodeReader.vue?vue&type=template&id=05d5739a&scoped=true"
import script from "./BaseBarcodeReader.vue?vue&type=script&lang=js"
export * from "./BaseBarcodeReader.vue?vue&type=script&lang=js"
import style0 from "./BaseBarcodeReader.vue?vue&type=style&index=0&id=05d5739a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d5739a",
  null
  
)

export default component.exports